<template>
  <div id="app">
    <navigation
      v-if="!disableNavigation"
      :collapsed="collapsed"
    />
    <main
      :class="{
        'fixed-sn': !disableNavigation,
        'fixed-double-sn': collapsed,
        'video-room': currentMenu == 'videoRoom',
        'service': currentMenu == 'service'
      }"
    >
      <transition mode="out-in">
        <forbidden v-if="forbidden"/>
        <not-found v-else-if="notFound"/>
        <internal-server-error v-else-if="showInternalServerError"/>
        <router-view v-else-if="showMainView"/>
      </transition>
    </main>
    <!-- <toast-notifications v-if="enableToastNotifications"/> -->
    <copyright-footer v-show="!disableNavigation"/>
    <member-modal/>
    <unusable-organization-modal v-if="unusable"/>
    <alert-change-organization-modal
      :modal="alertChangeOrganizationModal"
      :requiredOrganizationId="requiredOrganizationId"
      @close="alertChangeOrganizationModal = false"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import vueCookie from 'vue-cookie'

import Organization from '@/store/models/Organization'

// Errors
import Forbidden from '@/components/pages/errors/Forbidden.vue'
import NotFound from '@/components/pages/errors/NotFound.vue'
import InternalServerError from '@/components/pages/errors/InternalServerError.vue'

import Navigation from '@/components/organisms/Navigation'
// import ToastNotifications from '@/components/organisms/ToastNotifications'
import MemberModal from '@/components/organisms/MemberModal'
import UnusableOrganizationModal from '@/components/organisms/UnusableOrganizationModal'
import AlertChangeOrganizationModal from '@/components/organisms/AlertChangeOrganizationModal'

import CopyrightFooter from '@/components/molecules/CopyrightFooter'

export default {
  name: 'App',
  components: {
    CopyrightFooter,
    Forbidden,
    NotFound,
    InternalServerError,
    Navigation,
    // ToastNotifications,
    MemberModal,
    UnusableOrganizationModal,
    AlertChangeOrganizationModal
  },
  computed: {
    collapsed: function() {
      return this.$route.meta.sidebar === 'collapsed'
    },
    // enableToastNotifications: function() {
    //   return this.signedInUser && this.$route?.name !== 'indexRoom'
    // },
    disableNavigation: function() {
      return !this.$route?.name || this.$route?.meta?.requires?.disableNavigation
    },
    requiredOrganizationId: function() { return this.$route.query.required_organization_id },
    organizations: function() { return Organization.all() },
    showInternalServerError: function() {
      return this.internalServerError && !this.$route.name?.startsWith('service')
    },
    ...mapGetters({
      forbidden: 'forbidden',
      notFound: 'notFound',
      internalServerError: 'internalServerError',
      currentMenu: 'menu',
      httpSuccess: 'httpSuccess',
      httpError: 'httpError',
      unusable: 'unusable',
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      showMainView: false,
      alertChangeOrganizationModal: false
    }
  },
  methods: {
    ...mapMutations({
      setSignedInUserId: 'auth/signedInUserId'
    }),
    ...mapActions({
      validateAuth: 'auth/validate',
      apiPutAuth: 'auth/update',
      resetAllModulesAndEntities: 'resetAllModulesAndEntities'
    })
  },
  async created () {
    await this.validateAuth()

    // NOTE: 強制組織切り替え
    if (this.signedInUser &&
        this.requiredOrganizationId &&
        this.requiredOrganizationId != this.signedInUser.defaultOrganizationId &&
        this.organizations.map(organization => organization.id).includes(Number(this.requiredOrganizationId)))
    {
        this.alertChangeOrganizationModal = true

    } else {
      this.showMainView = true
    }
  },
  watch: {
    httpError (error) {
      if (!error) return
      if (error.response) {
        switch (error.response.status) {
          case 401: {
            const cookieOptions = {}
            if (process.env.NODE_ENV !== 'development' && process.env.VUE_APP_HOST) {
              cookieOptions.domain = process.env.VUE_APP_HOST
            }
            vueCookie.delete('session', cookieOptions)
            if (this.$route.name !== 'signIn') {
              this.setSignedInUserId(null)
              this.$router.push({ name: 'signIn' })
              this.resetAllModulesAndEntities()
            }
            break
          }
        }
      }
    }
  }
}
</script>

<style lang='scss'>
@import "@/styles/app.scss";
</style>
